import { DataHeader, DataSource, Layout, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommAlarmHistoryList extends Layout {
    dataheaderMCAlarmHistoryList: DataHeader;
    searchpanelMCAlarmHistory: SearchPanel;
    sourceMCAlarmHistory: DataSource;
    switchActive: Switch;
    tableMCAlarmHistory: Table;
    textboxAddress: Textbox;
    textboxDescr: Textbox;
    textboxUnit: Textbox;
}
